export const LIST_TYPES = {
  TEXT_LIST: "TextList",
  BUTTON_LIST: "ButtonList",
};
